





































































import { Component, Vue } from 'vue-property-decorator';
import Modal from '@/components/UI/Modal.vue';
import GmapAutocomplete from '@/components/Address/GmapAutocomplete.vue';
import ui from '@/store/modules/ui';
import checkout from '@/store/modules/checkout';
import store from '@/store';
import storelocator from '@/store/modules/storelocator';
import { StoreLocator } from '@/store/models';
import { calculateDistance } from '@/commons/gmap';

@Component({
  components: {
    Modal,
    GmapAutocomplete,
  },
})
export default class StorePickupMethod extends Vue {
  private modalId = 'storepickupSelection';
  private nearStores: StoreLocator[] = [];
  private noNearStores: boolean = false;
  private loading: boolean = true;
  private addressForPickupPoint = '';
  private preselectedStoreId = '';

  get hasPlaceError(): boolean {
    return checkout.hasPlaceErrorByCode('pickup_selection');
  }

  get preselectedStore() {
    return this.preselectedStoreId || this.selectedStore;
  }

  get selectedStore() {
    return storelocator.selectedStoreId;
  }

  get selectedStoreDetails(): StoreLocator {
    return storelocator.storeById(parseInt(this.selectedStore, 10));
  }

  private placeFoundHandler(place: google.maps.places.PlaceResult) {
    this.nearStores = [];
    const distances: any = {};
    this.noNearStores = false;
    const maxRange = store.state.options.gmap.storelocator_range;
    const geo: any = place.geometry;
    storelocator.stores.forEach((s) => {
      const distance = calculateDistance(geo.location.lng(), geo.location.lat(), s.longitude, s.latitude);
      // console.log(s);
      if (geo.location && distance <= maxRange) {
        this.nearStores.push(s);
        distances[s.storepickup_id] = distance;
      }
    });

    if (this.nearStores.length === 0) {
      this.noNearStores = true;
    } else {
      this.nearStores.sort((a: StoreLocator, b: StoreLocator) => {
        const pa = distances[a.storepickup_id] || 0;
        const pb = distances[b.storepickup_id] || 0;
        if (pa < pb) {
          return -1;
        }
        if (pb < pa) {
          return 1;
        }
        return 0;
      });
    }
  }

  private async selectStore(storeId: any) {
    this.preselectedStoreId = storeId;
  }

  private async saveSelectedStoreAndCloseModal() {
    this.loading = true;
    storelocator.setSelectedStoreId(this.preselectedStoreId);
    await storelocator.saveSelectedStore(this.preselectedStoreId);
    this.loading = false;
    this.toggleModal(false);
    this.$emit('storePickupSelected', this.preselectedStoreId);
  }

  private toggleModal(direction: boolean) {
    direction ? ui.openModal(this.modalId) : ui.closeModal(this.modalId) ;
  }
}
